import axios from "axios";

class AmeyaAuthService {

    user_setup = async (organization_id, user_id, reqObj) => {
        const auth_url = window.__ENV__.APPFLYTE_AUTHENTICATION_URL
        const schema_id = window.__ENV__.AMEYA_COLLECTIONS_SCHEMA_ID;
        const response = await axios.post(`${auth_url}/setup-ameya-user/${schema_id}/${organization_id}/${user_id}`, reqObj);
        return response;
    };

}
const AmeyaAuthApi = new AmeyaAuthService()
export default AmeyaAuthApi;